var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsights(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#8962D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 15.5C14.45 14.6277 14.9941 13.884 15.5328 13.143C15.675 12.9488 15.8172 12.7547 15.9539 12.5578C16.4953 11.7785 16.8125 10.8352 16.8125 9.81523C16.8125 7.15469 14.6578 5 12 5C9.34219 5 7.1875 7.15469 7.1875 9.8125C7.1875 10.8324 7.50469 11.7785 8.04609 12.5551C8.18281 12.752 8.325 12.9461 8.46719 13.1402C9.00859 13.8813 9.55273 14.6277 9.8125 15.4973H14.1875V15.5ZM12 19C13.2086 19 14.1875 18.0211 14.1875 16.8125V16.375H9.8125V16.8125C9.8125 18.0211 10.7914 19 12 19ZM9.8125 9.8125C9.8125 10.0531 9.61562 10.25 9.375 10.25C9.13437 10.25 8.9375 10.0531 8.9375 9.8125C8.9375 8.11992 10.3074 6.75 12 6.75C12.2406 6.75 12.4375 6.94687 12.4375 7.1875C12.4375 7.42812 12.2406 7.625 12 7.625C10.7914 7.625 9.8125 8.60391 9.8125 9.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsights);
export default __webpack_public_path__ + "static/media/insights.711529f302a1fc006151bee8c88fef41.svg";
export { ForwardRef as ReactComponent };